import { createSlice, PayloadAction } from 'ngrx-slice';

import { ErrorResponse } from '../interfaces/error-response.interface';

export interface ErrorState {
  errors: ErrorResponse[];
}

export const initialState: ErrorState = {
  errors: [],
};

export const {
  actions: ErrorActions,
  selectors: ErrorSelectors,
  ...ErrorFeature
} = createSlice({
  name: 'error',
  initialState,
  reducers: {
    resetErrors: (state) => {
      state.errors = [];
    },
    handleError: (state, action: PayloadAction<ErrorResponse>) => {
      const errors = [...state.errors, action];
      state.errors = errors;
    },
  },
});
